// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"124":"83cd13d24f65b75d00c4","447":"b2498acf53263daef639","872":"b4fdd6c2f371f94f59c7"}[chunkId] + ".js";
};